import React from 'react';

const IndexComponent = () => {
    return <div>Index</div>;
};

export default IndexComponent;